import React, { useEffect, useState } from 'react';
import { Container, Nav, NavItem, TabContent, TabPane } from 'reactstrap';
import { useSelector } from 'react-redux';
import classnames from 'classnames';

import { AgentCtxProvider } from './contexts/AgentCtx';
import { getDashboardChatIndividually } from './services/getBFFAgentDashboard';

import ChatTab from './components/DashboardTabs/chat';
import TelephonyTab from './components/DashboardTabs/telephony';
import ProtocolosTab from './components/DashboardTabs/protocols';

const Dashboard = () => {
  const telephonyServicePanelAgentCode = useSelector(
    (state) => state.telephonyServicePanel.agentCode
  );
  const telephonyServicePanelExtension = useSelector(
    (state) => state.telephonyServicePanel.extension
  );

  const [dashboardChatIndividually, setDashboardChatIndividually] = useState({
    averageFirstResponseTime: '00:00:00',
    averageServiceTime: '00:00:00',
    averageWaitingTime: '00:00:00',
    totalServiceTime: '00:00:00'
  });

  /** @typedef {'chat' | 'telefonia' | 'protocolos'} DashboardTabs */
  /** @type {[DashboardTabs, React.Dispatch<React.SetStateAction<DashboardTabs>>]} */
  const [activeTab, setActiveTab] = useState('chat');

  useEffect(() => {
    const login = localStorage.getItem('login');
    if (login) {
      getDashboardChatIndividually({ agent: 'adm' }).then((data) => {
        setDashboardChatIndividually(data.data);
      });
    }
  }, []);

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <>
      <AgentCtxProvider agent={telephonyServicePanelAgentCode}>
        <Container className="mt-6" fluid>
          <Nav tabs>
            <NavItem>
              <button
                className={classnames('nav-link', {
                  active: activeTab === 'chat'
                })}
                onClick={() => {
                  toggleTab('chat');
                }}
              >
                Chat
              </button>
            </NavItem>
            <NavItem>
              <button
                className={classnames('nav-link', {
                  active: activeTab === 'telefonia'
                })}
                onClick={() => {
                  toggleTab('telefonia');
                }}
              >
                Telefonia
              </button>
            </NavItem>
            <NavItem>
              <button
                className={classnames('nav-link', {
                  active: activeTab === 'protocolos'
                })}
                onClick={() => {
                  toggleTab('protocolos');
                }}
              >
                Protocolos
              </button>
            </NavItem>
          </Nav>
          <TabContent
            activeTab={activeTab}
            style={{
              paddingTop: '1rem'
            }}
          >
            <TabPane tabId="chat">
              <ChatTab dashboardChatIndividually={dashboardChatIndividually} />
            </TabPane>
            <TabPane tabId="telefonia">
              <TelephonyTab
                agent={telephonyServicePanelAgentCode}
                extension={telephonyServicePanelExtension}
                dashboardChatIndividually={dashboardChatIndividually}
              />
            </TabPane>
            <TabPane tabId="protocolos">
              <ProtocolosTab />
            </TabPane>
          </TabContent>
        </Container>
      </AgentCtxProvider>
    </>
  );
};

export default Dashboard;
